module.exports = __webpack_public_path__ + "img/id.b552039b.png";